import React from "react";
import Mileage from "./Mileage";
import { PageLayout, MileageSkeletonLoader } from "../../components";
import { MileageHelmet } from "../../components/SellHelmets";
import useMileageContainer from "./useMileageContainer";

export default function MileageContainer() {
  const {
    handleSubmit,
    handleWrongCar,
    readyToRender,
    setMileage,
    validationError,
    isBranchAppraisal,
    loading,
    mileage
  } = useMileageContainer();

  return (
    <>
      {!readyToRender ? (
        <>
          <MileageHelmet />
          <PageLayout>
            <PageLayout.Header title="Enter your mileage" step={2} />
            <PageLayout.Content>
              <MileageSkeletonLoader />
            </PageLayout.Content>
          </PageLayout>
        </>
      ) : (
        <Mileage
          onSubmit={handleSubmit}
          handleWrongCar={handleWrongCar}
          handleMileageInput={setMileage}
          validationError={validationError}
          isBranchAppraisal={isBranchAppraisal}
          loading={loading}
          mileage={mileage}
        />
      )}
    </>
  );
}
